import { render, staticRenderFns } from "./Form_Garante.vue?vue&type=template&id=b282cdc6"
import script from "./Form_Garante.vue?vue&type=script&lang=js"
export * from "./Form_Garante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b282cdc6')) {
      api.createRecord('b282cdc6', component.options)
    } else {
      api.reload('b282cdc6', component.options)
    }
    module.hot.accept("./Form_Garante.vue?vue&type=template&id=b282cdc6", function () {
      api.rerender('b282cdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Garante/MX/Form_Garante.vue"
export default component.exports